export const tr = {
    autoProlongation: 'Otomatik süre uzatma',
    avgBid: 'haftalık ortalama tıklama fiyatı',
    avgBidOpt: 'haftalık ortalama CPC',
    avgCpa: 'haftalık ortalama dönüşüm fiyatı',
    avgCpaOpt: 'haftalık ortalama CPA fiyatı',
    avgCpi: 'uygulama kurulumu için ortalama fiyat',
    avgCpm: '1000 gösterim başına ortalama fiyat',
    bid: 'haftalık maksimum tıklama fiyatı',
    'by-all-key-goals': 'Tüm anahtar hedeflere göre',
    clicksLimit: 'haftalık tıklama sayısı',
    'day-budget-sum': 'bütçe toplamı',
    default: 'Standart',
    filterAvgBid: 'her filtre için haftalık CPC',
    filterAvgCpa: 'her filtre için haftalık CPA',
    finish: 'zaman aralığının sonu',
    'fixed-cpm': 'todo',
    maxCpa: 'maksimum dönüşüm',
    'maximum-number-impressions': 'Minimum fiyata maksimum gösterim',
    'nedelnyy-byudzhet': 'Haftalık bütçe',
    'nedelnyy-paket-klikov': 'Haftalık tıklama paketi',
    'on-both-platforms': 'Tüm alanlarda',
    'on-net-platform': 'Ağlarda',
    'on-search-platform': 'Aramada',
    'optimizaciya-kolichestva-klikov-per-camp': 'Kampanya başına tıklama sayısı optimizasyonu',
    'optimizaciya-kolichestva-klikov-per-filter': 'Her filtre için tıklama sayısı optimizasyonu',
    'optimizaciya-kolichestva-konversiy-per-camp': 'Kampanya için dönüşüm sayısı optimizasyonu',
    'optimizaciya-kolichestva-konversiy-per-filter': 'Her filtre için dönüşüm sayısı optimizasyonu',
    'optimize-clicks': 'Tıklama optimizasyonu',
    'optimize-cpa': 'Dönüşüm optimizasyonu',
    'optimize-cpi': 'Uygulama kurulum sayısı optimizasyonu',
    'po-vsem-tselyam': 'Tüm hedeflerde',
    profitability: 'oranında gelir, ürünlerin veya hizmetlerin maliyet fiyatıdır',
    profitabilityValue: '%{profitability}',
    reserveReturn: 'oranında tasarruf edilen bütçe reklama geri aktarılsın',
    reserveReturnValue: '%{reserveReturn}',
    roi: 'Kârlılık optimizasyonu',
    roiCoef: 'haftalık ortalama yatırım kârlılığı',
    'ruchnoe-upravlenie-stavkami': 'Manuel teklif yönetimi',
    'ruchnoe-upravlenie-stavkami-generic': 'Manuel teklif yönetimi (ağlarda optimizasyona sahip)',
    'ruchnoe-upravlenie-stavkami-generic2': 'Manuel teklif yönetimi (optimizasyonlu)',
    'ruchnoe-upravlenie-stavkami-s-optimizaciei': 'Manuel teklif yönetimi ağlarda optimizasyona sahip',
    'ruchnoe-upravlenie-stavkami2': 'Optimizasyonlu manuel teklif yönetimi',
    separateBidding: 'Teklifleri aramada ve ağlarda bağımsız yönet',
    showMode: 'gösterim modu',
    'snizhenie-tseny-povtornyh-pokazov': 'Tekrarlanan gösterimler için fiyat düşürme',
    'srednyaya-cena-klika': 'Ortalama tıklama başına fiyat',
    'srednyaya-cena-konversii': 'Ortalama dönüşüm fiyatı',
    'srednyaya-cena-ustanovki-prilozheniya': 'Uygulamanın kurulumu için ortalama fiyat',
    start: 'zaman aralığının başlangıcı',
    stretched: 'dağıtılmış',
    sum: 'haftalık bütçe',
    tsel: 'Hedef "{goalName}"',
    'vse-tseli': 'Tüm hedefler',
    'week-budget-max-clicks': 'En yüksek tıklama sayısı',
    'week-budget-max-installations': 'Maksimum kurulum sayısı'
};
